import React, { FC } from 'react';
import {EdgeProps, getBezierPath, EdgeLabelRenderer, BaseEdge, getSmoothStepPath} from 'reactflow';
import Chip from "@mui/material/Chip";
import {sentenceCase} from "change-case";
import {
  CheckCircle, ErrorRounded,
  HourglassBottomRounded,
  HourglassTopRounded,
  SignalWifiStatusbarConnectedNoInternet4Rounded, WarningRounded
} from "@mui/icons-material";

const ConnectionEdge: FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  let status = data.status;
  let icon = <HourglassTopRounded color={'warning'} />
  let color: "default" | "error" | "success" | "warning" | "info" | "primary" | "secondary" | undefined = 'primary';
  switch(status) {
    case 'connected':
      color = 'success';
      icon = <CheckCircle color={'success'} />
      break;
    case 'disconnected':
      color = 'error';
      icon = <SignalWifiStatusbarConnectedNoInternet4Rounded color={'error'} />
      break;
    case 'warning':
      color = 'warning';
      icon = <WarningRounded color={'warning'} />
      break;
    case 'error':
      color = 'error';
      icon = <ErrorRounded color={'error'} />
      break;
    default:
      color = 'primary';
      break;
  }

  return (
    <>
      <BaseEdge id={id} path={edgePath} />
      <EdgeLabelRenderer>
        <div style={{position: 'absolute', transform: `translate(-50%, -50%) translate(${targetX + 50}px,${targetY}px)`}}>
          {icon}
        </div>
        {/*<Chip label={status} sx={{*/}
        {/*  textTransform: 'capitalize',*/}
        {/*  position: 'absolute',*/}
        {/*  transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,*/}
        {/*  borderRadius: '20px',*/}
        {/*  padding: '4px 8px !important',*/}
        {/*  fontSize: '1rem',*/}
        {/*  fontWeight: '400',*/}
        {/*  lineHeight: '21px',*/}
        {/*}} size={'small'} variant="filled" color={color} />*/}
      </EdgeLabelRenderer>
    </>
  );
};

export default ConnectionEdge;